var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "blocks" }, [
        _c(
          "div",
          {
            staticClass:
              "pt-3 l-m-b-20 align-items-center d-flex justify-content-between"
          },
          [
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("h1", { staticClass: "pr-3" }, [_vm._v("Users")]),
              _vm._v(" "),
              _c("div", { staticClass: "input-group search" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn input-group-btn",
                    attrs: { type: "button" },
                    on: { click: _vm.clearSearch }
                  },
                  [
                    _c("i", {
                      class: [_vm.q ? "fa fa-remove" : "fa fa-search"]
                    })
                  ]
                ),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.q,
                      expression: "q"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Search" },
                  domProps: { value: _vm.q },
                  on: {
                    keyup: function($event) {
                      _vm.searchText($event)
                    },
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.q = $event.target.value
                    }
                  }
                })
              ])
            ]),
            _vm._v(" "),
            _vm.$_can("clusters.users.store")
              ? _c("div", { staticClass: "text-right" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      on: {
                        click: function($event) {
                          _vm.showCreateSidebar = !_vm.showCreateSidebar
                        }
                      }
                    },
                    [_vm._v("\n          ADD USER\n        ")]
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-11 filters-field" }, [
            _c("span", [_vm._v("Filters:")]),
            _vm._v(" "),
            _vm.filtersLoaded
              ? _c("span", [
                  _vm.filters.carrier.length &&
                  _vm.carriers &&
                  _vm.carriers.length
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.carrier, function(carrier) {
                          return _c(
                            "span",
                            {
                              key: carrier,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("carrier", carrier)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Carrier: " +
                                  _vm._s(
                                    _vm.carriers.find(function(el) {
                                      return el.id === carrier
                                    }).name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.company.length &&
                  _vm.companies &&
                  _vm.companies.length
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.company, function(company) {
                          return _c(
                            "span",
                            {
                              key: company,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("company", company)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Company: " +
                                  _vm._s(
                                    _vm.companies.find(function(el) {
                                      return el.id === company
                                    }).name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.role.length && _vm.roles && _vm.roles.length
                    ? _c(
                        "span",
                        _vm._l(_vm.filters.role, function(role) {
                          return _c(
                            "span",
                            {
                              key: role,
                              staticClass: "filter-item btn btn-filter"
                            },
                            [
                              _c("span", {
                                staticClass: "mod-icon-filter",
                                on: {
                                  click: function($event) {
                                    _vm.removeFilter("role", role)
                                  }
                                }
                              }),
                              _vm._v(
                                "\n              Role: " +
                                  _vm._s(
                                    _vm.roles.find(function(el) {
                                      return el.id === role
                                    }).name
                                  )
                              )
                            ]
                          )
                        })
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.filters.status &&
                  _vm.userStatuses &&
                  _vm.userStatuses.length > 0
                    ? _c(
                        "span",
                        { staticClass: "filter-item btn btn-filter" },
                        [
                          _c("span", {
                            staticClass: "mod-icon-filter",
                            on: {
                              click: function($event) {
                                _vm.removeFilter("status")
                              }
                            }
                          }),
                          _vm._v(
                            "\n            Status: " +
                              _vm._s(
                                _vm.userStatuses.find(function(el) {
                                  return el.id === _vm.filters.status
                                }).name
                              )
                          )
                        ]
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary add-filters",
                on: {
                  click: function($event) {
                    _vm.showFilters = true
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-plus filter-icon" })]
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-1 d-flex justify-content-end" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary expand-all",
                on: { click: _vm.toggleAllUsers }
              },
              [
                _c("i", {
                  class: [
                    _vm.users && _vm.expandedAll
                      ? "fa fa-compress"
                      : "fa fa-expand"
                  ]
                })
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      !_vm.users
        ? [
            _c(
              "vue-content-loading",
              { attrs: { width: 800, height: 450 } },
              _vm._l(15, function(x) {
                return _c("rect", {
                  key: x,
                  attrs: {
                    x: "10",
                    y: 15 * x * 1.4,
                    rx: "5",
                    ry: "5",
                    width: "720",
                    height: "6"
                  }
                })
              })
            )
          ]
        : [
            _c(
              "div",
              { staticClass: "blocks" },
              _vm._l(_vm.users, function(user, index) {
                return _c("UsersBlock", {
                  key: index,
                  attrs: { user: user, expanded: _vm.expanded, q: _vm.q },
                  on: {
                    "update:user": function($event) {
                      user = $event
                    },
                    expanded: _vm.toggleUser,
                    update: _vm.getUsers,
                    setFiltersSaved: _vm.callSetFiltersSaved
                  }
                })
              })
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "row blocks" },
              [
                _vm.meta.total
                  ? _c(
                      "div",
                      { staticClass: "col-sm-6 mb-1 text-black-50 pl-0" },
                      [
                        _vm._v(
                          "\n        Showing " +
                            _vm._s(_vm.meta.from) +
                            " - " +
                            _vm._s(_vm.meta.to) +
                            " of " +
                            _vm._s(_vm.meta.total) +
                            "\n      "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("pagination", {
                  staticClass: "col-sm-6 mb-1 pr-0",
                  attrs: { "change-page": _vm.changePage, meta: _vm.meta }
                })
              ],
              1
            )
          ],
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showFilters
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showFilters = false
                  }
                }
              },
              [
                _vm.showFilters
                  ? _c(
                      "div",
                      { staticClass: "filters-side-modal flex flex-column" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "pointer",
                            on: {
                              click: function($event) {
                                _vm.showFilters = !_vm.showFilters
                              }
                            }
                          },
                          [
                            _c("h1", { staticClass: "modal-h1 l-m-b-20" }, [
                              _c("span", { staticClass: "btn btn-back" }),
                              _vm._v("Add Filter")
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c("p", [
                            _vm._v(
                              "\n            Filters are applied automatically. You can remove them one by one with minus button or with clear filters button.\n          "
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "l-bg-white" }, [
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              _c("div", { staticClass: "row filters" }, [
                                _vm.companies && _vm.companies.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Company")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.companies,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "company-select",
                                              placeholder: "Select Company",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.company,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "company",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.company"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.carriers && _vm.carriers.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Carriers")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.carriers,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "carrier-select",
                                              placeholder: "Select Carriers",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.carrier,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "carrier",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.carrier"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.roles && _vm.roles.length
                                  ? _c("div", { staticClass: "col-12" }, [
                                      _c(
                                        "div",
                                        { staticClass: "select-wrap" },
                                        [
                                          _c("label", [_vm._v("Role")]),
                                          _vm._v(" "),
                                          _c("key-multiselect", {
                                            attrs: {
                                              options: _vm.roles,
                                              multiple: true,
                                              "clear-on-select": false,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              id: "role-select",
                                              placeholder: "Select Role",
                                              "preserve-search": false,
                                              label: "name",
                                              "track-by": "id"
                                            },
                                            on: { input: _vm.search },
                                            scopedSlots: _vm._u([
                                              {
                                                key: "tag",
                                                fn: function(props) {
                                                  return [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "multiselect__tag"
                                                      },
                                                      [
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              props.option.name
                                                            )
                                                          )
                                                        ]),
                                                        _vm._v(" "),
                                                        _c("span", {
                                                          staticClass:
                                                            "multiselect__tag-icon",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              props.remove(
                                                                props.option
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ]
                                                    )
                                                  ]
                                                }
                                              }
                                            ]),
                                            model: {
                                              value: _vm.filters.role,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filters,
                                                  "role",
                                                  $$v
                                                )
                                              },
                                              expression: "filters.role"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "col-12" }, [
                                  _c(
                                    "div",
                                    { staticClass: "select-wrap" },
                                    [
                                      _c("label", [_vm._v("Status")]),
                                      _vm._v(" "),
                                      _c("simple-select", {
                                        attrs: {
                                          options: _vm.userStatuses,
                                          placeholder: "Select Status"
                                        },
                                        on: { input: _vm.search },
                                        model: {
                                          value: _vm.filters.status,
                                          callback: function($$v) {
                                            _vm.$set(_vm.filters, "status", $$v)
                                          },
                                          expression: "filters.status"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "row mt-auto" }, [
                          _c("div", { staticClass: "col" }, [
                            !_vm.clearFiltersButtonShouldBeDisabled
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-not-active text-dark w-100",
                                    attrs: { type: "button" },
                                    on: { click: _vm.clearFilters }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Clear filters\n            "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        ])
                      ]
                    )
                  : _vm._e()
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "slide-fade" } }, [
        _vm.showCreateSidebar
          ? _c(
              "div",
              {
                staticClass: "l-modal-mask",
                on: {
                  click: function($event) {
                    if ($event.target !== $event.currentTarget) {
                      return null
                    }
                    _vm.showCreateSidebar = false
                  }
                }
              },
              [
                _c("users-create", {
                  staticClass: "sidebar-right",
                  on: {
                    cancel: function($event) {
                      _vm.showCreateSidebar = false
                    },
                    update: _vm.updateAfterCreating
                  }
                })
              ],
              1
            )
          : _vm._e()
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f5554e7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f5554e7e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/users/Users.vue
// module id = null
// module chunks = 